<template>
  <div id="app">
    <img src="./assets/logo.png">
    <div v-if="isLoading" class="activity">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
    <div v-else class="container">
      <div class="header">
        <h1>{{localized.headerText}}</h1>
        <ul>
          <li><router-link :to="route.main">Home</router-link></li>
          <li><router-link :to="route.contact">Contact Us</router-link></li>
          <li v-if="!hasUser"><router-link :to="route.login">Developer Login</router-link></li>
          <li v-if="hasUser"><router-link :to="route.messages">Messages</router-link></li>
        </ul>
      </div>
      <div class="content">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import route from './routes-types'
export default {
  name: 'App',
  data () {
    return {
      route,
      localized: {
        headerText: 'ITlekt Corporation'
      }
    }
  },
  computed: {
    hasUser () {
      return this.$store.getters.user != null
    },
    isLoading () {
      return this.$store.getters.loading
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #3B4357;
  margin-top: 60px;
}
h1, h2, h3 {
  font-weight: normal;
}
.header a {
  text-decoration: none;
  color: #3B4357;
}
.header ul {
  list-style-type: none;
  padding: 0;
}
.header li {
  display: inline-block;
  margin: 0 10px;
}
.activity {
  margin: 16px 0 16px 0;
}
.content {
  max-width: 600px;
  margin: 32px auto 32px;
}
/* .router-link-active, */
.router-link-exact-active {
  text-decoration: none;
  border-bottom: 4px solid #F1A82E;
}
</style>



// WEBPACK FOOTER //
// src/App.vue